import createOpenApiClient from "openapi-fetch";
import { apiFetchRequest, getOpenApiClientBaseUrl } from "../lib/edu-api-client";
import type { paths } from "@airange/generated-contracts/edu";

export const eduAdminOpenApiClient = createOpenApiClient<paths>({
  baseUrl: getOpenApiClientBaseUrl(),
  fetch: apiFetchRequest,
});
